import React from 'react';
import PropTypes from 'prop-types';
import { styled } from '@uhg-abyss/web/tools/styled';
import { StepTracker } from '@uhg-abyss/web/ui/StepTracker';
import { Text } from '@uhg-abyss/web/ui/Text';

const Container = styled('div', {
  paddingBottom: '32px',
  paddingTop: '32px',
  background: 'rgb(255, 255, 255)',
  borderBottomLeftRadius: 4,
  borderBottomRightRadius: 4,
});

const TrackerHeader = styled('div', {
  textAlign: 'center',
  paddingTop: '1%',
  paddingBottom: '2%',
});

export const OrganizationTracker = ({ currentStep }) => {
  return (
    <Container>
      <TrackerHeader>
        <Text id="tracker-label" fontSize="lg">
          API Subscription Request Status
        </Text>
      </TrackerHeader>
      <StepTracker currentStep={currentStep}>
        <StepTracker.Step
          id="step-request-submitted"
          label="Request Submitted"
        />
        <StepTracker.Step id="step-review" label="Reviewing Request" />
        <StepTracker.Step id="step-approved" label="API Request Approved" />
      </StepTracker>
    </Container>
  );
};

OrganizationTracker.propTypes = {
  currentStep: PropTypes.number.isRequired,
};
